// extracted by mini-css-extract-plugin
module.exports = {"oddEvenCard":"cx_h6","coverImageSection":"cx_hk","even":"cx_hh","odd":"cx_hj","coverImage":"cx_d8","descriptionSection":"cx_cl","title":"cx_6"};